import pluralize from 'pluralize';
import React from 'react';

import { pollDaysRemaining } from '@utils/backend-api/polls';

interface PollResultProps {
  totalVotes: number;
  expiresAt?: string | null;
  pollClosed?: boolean;
  canVote?: boolean;
  userVoted?: boolean;
}

function Byline({
  children,
  variant = 'muted',
}: {
  children: React.ReactNode;
  variant?: 'muted' | 'emphasis';
}) {
  return (
    <span
      className={`font-suisse-screen text-byline-sm ${
        variant === 'emphasis' ? 'text-black' : 'text-grayscale-gray'
      }`}
    >
      {children}
    </span>
  );
}

function Dot() {
  return <Byline>&middot;</Byline>;
}

export default function PollResult({
  totalVotes,
  expiresAt,
  pollClosed,
  canVote,
  userVoted,
}: PollResultProps) {
  const daysLeft = pollDaysRemaining(expiresAt);

  if (totalVotes <= 0) {
    if (canVote && !userVoted) {
      return (
        <div className="px-12">
          <Byline variant="emphasis">Be first to vote</Byline>
        </div>
      );
    }
    return null;
  }

  let statusMessage: string;
  if (userVoted) {
    statusMessage = 'Thanks for voting!';
  } else if (daysLeft > 1) {
    statusMessage = `${pluralize('day', daysLeft, true)} left to vote`;
  } else if (!pollClosed) {
    statusMessage = 'Less than a day left to vote';
  } else {
    statusMessage = '';
  }

  return (
    <div className="px-12">
      <Byline>{pluralize('vote', totalVotes, true)}</Byline>
      {statusMessage !== '' && <Dot />}
      <Byline variant="emphasis">{statusMessage}</Byline>
    </div>
  );
}
